if (!customElements.get('video-facade')) {
  customElements.define(
    'video-facade',
    class VideoFacade extends HTMLElement {
      static get observedAttributes() {
        return ['src', 'autoplay']
      }

      connectedCallback() {
        this._loaded = false
        this._observer = null
        setTimeout(() => this._setup(), 0)
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect()
          this._observer = null
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.isConnected) {
          this.disconnectedCallback()
          this._loaded = false
          this._setup()
        }
      }

      get isAutoplay() {
        return this.hasAttribute('autoplay')
      }

      _setup() {
        const src = this.getAttribute('src')
        if (!src) return

        const poster = this.querySelector('.video-facade__poster')
        const playBtn = this.querySelector('.video-facade__play-btn')
        const videoDiv = this.querySelector('.video-facade__video')
        const errorDiv = this.querySelector('.video-facade__error')

        if (this.isAutoplay) {
          if ('IntersectionObserver' in window) {
            this._observer = new IntersectionObserver(
              (entries, obs) => {
                if (entries[0].isIntersecting) {
                  obs.disconnect()
                  this._loadVideo(poster, videoDiv, errorDiv)
                }
              },
              {threshold: 0, rootMargin: '200px 0px'},
            )
            this._observer.observe(this)
          } else {
            this._loadVideo(poster, videoDiv, errorDiv)
          }
        } else {
          const load = this._loadVideo.bind(this, poster, videoDiv, errorDiv)
          if (poster) poster.addEventListener('click', load)
          if (playBtn)
            playBtn.addEventListener('click', e => {
              e.stopPropagation()
              load()
            })
        }
      }

      _loadVideo(poster, videoDiv, errorDiv) {
        if (this._loaded) return
        this._loaded = true

        const src = this.getAttribute('src')
        this.classList.add('is-loading')

        const video = document.createElement('video')
        video.src = src
        video.preload = 'metadata'

        if (this.isAutoplay) {
          video.autoplay = true
          video.muted = true
          video.loop = true
          video.controls = false
          video.playsInline = true
          video.setAttribute('webkit-playsinline', 'true')
        } else {
          video.controls = true
        }

        video.addEventListener('loadedmetadata', () => {
          if (poster) poster.hidden = true
          if (videoDiv) videoDiv.hidden = false
          this.classList.remove('is-loading')
          video.play().catch(e => {
            console.warn('[video-facade] play() rejected:', e)
          })
        })

        video.addEventListener('error', () => {
          this._loaded = false
          this.classList.remove('is-loading')
          if (errorDiv) {
            errorDiv.textContent = 'Video unavailable'
            errorDiv.hidden = false
          }
          console.warn('[video-facade] failed to load:', src)
        })

        video.addEventListener('play', () => {
          this.classList.add('is-playing')
          if (typeof gtag !== 'undefined') {
            gtag('event', 'video_play', {video_url: src, autoplay: this.isAutoplay})
          }
        })

        if (videoDiv) videoDiv.appendChild(video)
        video.load()
      }
    },
  )

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('video-facade').forEach(el => {
      el.disconnectedCallback()
      el._loaded = false
      el._setup()
    })
  })

  document.addEventListener('shopify:block:select', e => {
    const el = e.target.querySelector('video-facade')
    if (el) {
      el.disconnectedCallback()
      el._loaded = false
      el._setup()
    }
  })
}
